import styled, { css } from 'styled-components'
import { ChevronIcon as Chevron } from '@sainsburys-tech/bolt-icons'
import { remCalculator } from '../../../../helpers/theming/utilities'

const transitionPeriod = (isHidden) => (isHidden ? 300 : 0)

const ChevronButton = styled.button`
  background: transparent;
  top: 0;
  height: 50px;
  width: 50px;

  ${(props) =>
    props.dir === 'left' &&
    css`
      left: -${remCalculator(props.theme.size.spacing.md)};
    `}

  ${(props) =>
    props.dir === 'right' &&
    css`
      right: -${remCalculator(props.theme.size.spacing.md)};
      @media screen and (max-width: ${props.theme.size.breakpoint['max-width'].xs}) {
        right: 0;
      }
    `}

  ${(props) =>
    props.hide &&
    css`
      visibility: hidden;
      opacity: 0;
    `}

    ${(props) =>
    props.imageStyle
      ? css`
          top: ${props.imageStyle === 'square' ? '30%' : '15%'};
        `
      : css`
          width: 30px;
          height: 30px;
        `}

  position: absolute;
  border: 0;

  border-radius: 50%;
  z-index: 2;
  transition: visibility 0s linear ${(props) => transitionPeriod(props.hide)}ms, opacity 200ms;

  svg {
    display: block;
    margin: auto;
  }

  &:focus {
    outline: -webkit-focus-ring-color auto 5px;
  }
`

const ChevronIcon = styled(Chevron)`
  fill: ${(props) => props.theme.color.monochrome.black};
`

export { ChevronButton, ChevronIcon }
